import clsx from 'clsx'
import React, { useCallback, useState } from 'react'

const estilosFormulario = require('../../estilos/formulario.module.scss').default
const estilosBotoes = require('../../estilos/botoes.module.scss').default

type SolicitarSenhaProps = {
    dicaPermissao?: string,
    onSenhaInformada: (senha:string) => void
}

const SolicitarSenha = (props:SolicitarSenhaProps) => {
    const [senha,setSenha] = useState("")

    const [isCapsLockOn, setIsCapsLockOn] = useState(false)

    const checkCapsLock = useCallback((event) => {
            if (event && typeof event.getModifierState === 'function') {
                setIsCapsLockOn(event.getModifierState('CapsLock'));
              }
    }, [])


    return <>
        <div className={clsx(estilosFormulario.formulario,"_max-w-md")}>
            <label
                title={props.dicaPermissao != null && props.dicaPermissao != "" ? `${props.dicaPermissao}]` : ""}
            >Senha</label>
            <input type="password" 
                onChange={e => setSenha(e.target.value)}
                id="SolicitarSenha_inputSenha"
                autoFocus
                onKeyUp={checkCapsLock}
                onFocus={checkCapsLock}
                autoComplete="off"
                list="autocompleteOff" // para naos mostrar dados digitados anteriormente
                aria-autocomplete="none"
                onBlur={() => setIsCapsLockOn(false)}
                onKeyPress={e => {
                    if (e.key == 'Enter') {
                        props.onSenhaInformada(senha)
                    }
                }}/>

            <label></label>
            <button className={clsx(estilosBotoes.botaoPrimario,"_w-16")}
                id="SolicitarSenha_botaoOk"
                onFocus={() => setIsCapsLockOn(false)}
                onClick={() => props.onSenhaInformada(senha)}>
                OK
            </button>
        </div>
            {isCapsLockOn && (<div>
                    <span
                        style={{ color: "red", fontWeight: "bold", }}
                        >CapsLock está ativado
                        </span>
                        </div>
                )}

    </>
}

export {
    SolicitarSenha,
    SolicitarSenhaProps
}
